<ul class="password-rules-viewer__rules-container">
    <li *ngFor="let rule of passwordValidationRules"
        class="password-rules-viewer__rule"
        [ngClass]="{'password-rules-viewer__rule--passed': !hasError(rule.name)}"
        [mmTestTarget]="'password-security-rule-' + rule.name">
        <span class="password-rule__title">{{ rule.title | translate }}</span>
        <span *ngIf="!hasError(rule.name)"
              class="password-rule__checkmark"
              [mmTestTarget]="'password-security-rule-implemented-mark'">
                <mm-icon [name]="'check-mark-small'"
                         [type]="'fluid'"
                         class="password-rule__icon"></mm-icon>
        </span>
    </li>
</ul>
